/**
 * Whether the signed-in session is a member of `userGroupId`.
 *
 * The user group a stationary checkout acts for is not always one of the
 * session's own: the group a proposal was issued to, or the customer a
 * staff-created booking belongs to.
 * The backend gates every group-scoped call on plain membership
 * (`user_is_member_of_user_group`), so a non-member is refused whichever
 * group is "selected" in the client — selection is client state and is never
 * sent.
 *
 * Absent or empty membership is NOT access. `userGroups` arrives complete with
 * the session rather than incrementally, so `[]` means a session with zero
 * memberships — not one still loading — and answering `true` would let an
 * unverified organization be selected and start the very calls this guards.
 *
 * This cannot express "not known yet": a caller that must keep blocking while
 * the session is genuinely absent checks `userData` itself and does not ask
 * this question at all. `useProfileAddressGate` does.
 */
export function isUserGroupMember(
  userGroupId: number | null | undefined,
  userGroups: readonly { id: number }[] | null | undefined
): boolean {
  if (userGroupId == null || !userGroups) {
    return false;
  }
  return userGroups.some((userGroup) => userGroup.id === userGroupId);
}
